export default {
  header: {
    title: 'Comprar tarjeta regalo',
  },
  items: {
    gift_card: {
      label: 'Tarjeta regalo',
      title: 'Selecciona el importe deseado',
      description: 'Añade la tarjeta regalo con la cantidad deseada al carrito',
    },
    expiration: {
      label: 'Válida 3 años',
      title: '¡Disfruta regalando!',
      description: 'El destinatario puede canjear el vale de forma flexible en 3 años.',
    },
    delivery: {
      label: 'Entrega inmediata en PDF por correo',
      title: 'Entrega instantánea en PDF por correo',
      description: 'Tras el pago seguro con tarjeta de crédito, PayPal o giropay, recibirás el vale de inmediato.',
    },
  },
  form: {
    value: {
      title: 'Elige el importe de la tarjeta regalo',
      custom: {
        label: 'Personalizado',
        placeholder: 'Introduce el importe',
      },
    },
    quantity: {
      title: 'Cantidad',
    },
    email: {
      title: '¿Cuál es tu dirección de correo para enviarte la tarjeta regalo?',
      placeholder: 'Tu dirección de correo',
    },
  },
  confirmation: {
    title: {
      title: '¿Crear tarjeta regalo?',
      subtitle_one: '¿Deseas crear 1 tarjeta regalo por {{value}}?',
      subtitle_other: '¿Deseas crear {{count}} tarjetas regalo por {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'Correo:',
      quantity: 'Cantidad',
      amount: 'Importe',
    },
    footer: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
    },
  },
  buttons: {
    create: 'Crear',
  },
  toasts: {
    error: 'Error al crear la tarjeta regalo.',
    success: 'Tarjeta regalo creada con éxito.',
  },
};
